export var NodeType;
(function (NodeType) {
    NodeType[NodeType["ELEMENT_NODE"] = 1] = "ELEMENT_NODE";
    NodeType[NodeType["TEXT_NODE"] = 3] = "TEXT_NODE";
    NodeType[NodeType["DOCUMENT_NODE"] = 9] = "DOCUMENT_NODE";
})(NodeType || (NodeType = {}));
export const convertDomNodeAttributes = (domNodeAttributes) => {
    const convertedAttributes = {};
    for (const attr of domNodeAttributes) {
        convertedAttributes[attr.name] = attr.value;
    }
    return convertedAttributes;
};
export const isRootNode = (domNode) => domNode.nodeType === NodeType.DOCUMENT_NODE;
export const isTextNode = (domNode) => domNode.nodeType === NodeType.TEXT_NODE;
export const isElementNode = (domNode) => domNode.nodeType === NodeType.ELEMENT_NODE;
